module.exports = __webpack_public_path__ + "img/right-flag.fbf1f77c.svg";